import { PROFILE_TYPES } from "utils/helpers/enums/shared.enum";

export class AmbassadorDTO {
    commitmentLength: string = '';
    createdAt: string = '';
    engagementLevel: string = '';
    id: number;
    mission: string = '';
    points: string = '';
    profileCompleted: boolean = false;
    profileType: PROFILE_TYPES = PROFILE_TYPES.LEADER;
    referralCode: string = '';
    skills: string = '';
    updatedAt: string = '';
    userId: number;

    constructor(data: Partial<AmbassadorDTO> = {}) {
        for (let key in data) {
            this[key] = data[key];
        }
    }
}
